import { Box } from '@chakra-ui/react';

interface TexasDrawerFooterProps {
  children: React.ReactNode;
}

export function TexasDrawerFooter(props: TexasDrawerFooterProps) {
  return <Box padding={4}>{props.children}</Box>;
}
